import { render, staticRenderFns } from "./DashboardAvatar.vue?vue&type=template&id=261ab5de&"
import script from "./DashboardAvatar.vue?vue&type=script&lang=js&"
export * from "./DashboardAvatar.vue?vue&type=script&lang=js&"
import style0 from "./DashboardAvatar.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
installComponents(component, {VAvatar})
